/**
 * MOZTECH Premium Master Animations
 * ----------------------------------------
 * Centralized GSAP controller.
 * Prevents multiple sections from instantiating GSAP ScrollTriggers independently,
 * which causes scroll lag and memory leaks.
 */

window.MoztechAnimations = (() => {
  let isInitialized = false;
  const triggerPrefix = 'moztech-master';

  const loadGSAP = (callback) => {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      callback();
      return;
    }
    
    const script = document.createElement('script');
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js";
    script.onload = () => {
      const triggerScript = document.createElement('script');
      triggerScript.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js";
      triggerScript.onload = callback;
      document.head.appendChild(triggerScript);
    };
    document.head.appendChild(script);
  };

  const initHeroAnimations = () => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches || !window.matchMedia("(pointer: fine)").matches;
    const burnManagedHero = document.querySelector('.moztech-hero-container.has-burn-reveal[data-burn-motion="scroll"]');
    const heroMedia = document.querySelector('.moztech-hero-bg');
    const heroContent = document.querySelector('.moztech-hero-content');
    const heroIntroTargets = document.querySelectorAll('.moztech-hero-title, .moztech-hero-subtitle, .hero-spec-badge, .brand-btn');

    // The reversible Luma reveal owns media/content transforms and opacity.
    // Running the legacy GSAP hero timeline as well freezes its initial hidden state.
    if (burnManagedHero) return;
    
    // --- Cinematic Entrance Animation (Page Load) ---
    const entranceTl = gsap.timeline({ defaults: { ease: 'power4.out' } });
    
    // Set initial states
    if (heroIntroTargets.length > 0) {
      gsap.set(heroIntroTargets, { opacity: 0, y: 40 });
    }
    if (heroMedia) {
      gsap.set(heroMedia, { scale: 1.1, filter: 'blur(8px)' });
    }

    if (heroMedia) {
      entranceTl.to(heroMedia, { scale: 1.05, filter: 'blur(0px)', duration: 2.5, ease: 'power2.out' }, 0);
    }
    if (heroIntroTargets.length > 0) {
      entranceTl.to(heroIntroTargets, { opacity: 1, y: 0, duration: 1, stagger: 0.1 }, 0.3);
    }

    // --- Scroll Parallax Animation ---
    if (!isMobile && heroMedia) {
      gsap.to(heroMedia, {
        scrollTrigger: {
          id: `${triggerPrefix}-hero-media`,
          trigger: '.moztech-hero-container',
          start: 'top top',
          end: 'bottom top',
          scrub: 1
        },
        y: 150,
        opacity: 0.2,
        ease: 'none'
      });
    }
      
    if (!isMobile && heroContent) {
      gsap.to(heroContent, {
        scrollTrigger: {
          id: `${triggerPrefix}-hero-content`,
          trigger: '.moztech-hero-container',
          start: 'top top',
          end: 'bottom top',
          scrub: 1
        },
        y: -100,
        opacity: 0,
        ease: 'power1.in'
      });
    } else if (heroContent) {
      gsap.to(heroContent, {
        scrollTrigger: {
          id: `${triggerPrefix}-hero-content-mobile`,
          trigger: '.moztech-hero-container',
          start: 'top top',
          end: 'bottom top',
          scrub: true
        },
        opacity: 0,
        y: -50,
        ease: 'none'
      });
    }
  };

  const initBentoAnimations = () => {
    const cards = document.querySelectorAll('.moztech-bento-card');
    if (cards.length === 0) return;

    gsap.set(cards, {
      clearProps: 'opacity,transform'
    });
  };

  const init = () => {
    if (isInitialized) return;
    isInitialized = true;
    
    loadGSAP(() => {
      gsap.registerPlugin(ScrollTrigger);
      
      ScrollTrigger.getAll().forEach((trigger) => {
        if (trigger.vars && typeof trigger.vars.id === 'string' && trigger.vars.id.startsWith(triggerPrefix)) {
          trigger.kill();
        }
      });

      if (document.querySelector('.moztech-hero-container')) {
        initHeroAnimations();
      }
      
      if (document.querySelector('.moztech-bento-grid')) {
        initBentoAnimations();
      }
      
      ScrollTrigger.refresh();
    });
  };

  return { init };
})();

document.addEventListener('DOMContentLoaded', window.MoztechAnimations.init);
document.addEventListener('shopify:section:load', () => {
  setTimeout(() => {
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  }, 100);
});
